import cn from '@integrations/classnames'
import type { HTMLAttributes } from '@integrations/react'
import styles from './ModalContentSurface.module.scss'

type ModalContentSurfaceSize = 'default' | 'wide'

interface Props extends HTMLAttributes<HTMLDivElement> {
  size?: ModalContentSurfaceSize
}

function ModalContentSurface({ size = 'default', className, children, ...props }: Props) {
  return (
    <div
      className={cn(styles['modal-content-surface'], 'modal-content-surface', className, {
        [styles['modal-content-surface-wide']]: size === 'wide'
      })}
      {...props}
    >
      {children}
    </div>
  )
}

/** Supporting line under a `ModalTitle` (e.g. "EUR account · ID 3669359"). */
export function ModalSubtitle({ className, children, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p className={cn(styles['modal-subtitle'], 'modal-subtitle', className)} {...props}>
      {children}
    </p>
  )
}

/** Right-aligned action row closing a modal form: secondary (Cancel) first, primary last. */
export function ModalFooter({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn(styles['modal-footer'], 'modal-footer', className)} {...props}>
      {children}
    </div>
  )
}

export default ModalContentSurface
